<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="企业实习资源列表">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="enterpriseName"
              placeholder="search by title"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveEnterprisePracticeResource' }">新增实习资源</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listResource"
          api-mode
        >
          <template slot="cover" slot-scope="props">
            <img :src="props.rowData.enterpriseImageUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-pencil"
              :to='{path:`updateEnterprisePracticeResource/${props.rowData.id}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除企业实习资源"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import enterprisePracticeResourceApi from '../../api/enterprisePracticeResource'

export default {
  data () {
    return {
      message: ['Required field'],
      serviceId: 3,
      resources: [],
      enterpriseName: '',
      loading: true,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:cover',
          width: '60px',
        }, {
          name: 'enterpriseName',
          title: '企业名称',
          width: '20%',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: 'enterpriseDescription',
          title: '公司介绍',
          width: '60%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.enterpriseName || this.enterpriseName.length < 1) {
        return this.resources
      }
      return this.resources.filter(item => {
        return item.enterpriseName.toLowerCase().startsWith(this.enterpriseName.toLowerCase())
      })
    },
  },
  created () {
    this.listResource()
  },
  methods: {
    listResource (pageNumber = 1) {
      this.loading = true
      const params = {
        serviceId: this.serviceId,
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      enterprisePracticeResourceApi.listEnterprisePracticeResource(params)
        .then(response => {
          this.resources = response.enterprisePracticeResources
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      enterprisePracticeResourceApi.deleteEnterprisePracticeResource(this.deleteId).then(response => {
        if (response.success === true) {
          this.listResource()
        }
      }).catch(error => alert(error))
    },
    search: debounce(function (enterpriseName) {
      this.enterpriseName = enterpriseName
    }, 400),
    updateSortNum: function (params) {
      enterprisePracticeResourceApi.updateEnterprisePracticeResource(params.id, params).then(response => {
        if (response.success === true) {
          this.listResource()
        }
      }).catch(error => alert(error))
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
